import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

const unwrap = res => res.data;

const emptyCards = {
  active_campaigns: 0,
  reported_streams: 0,
  removed_streams: 0,
  removal_success_rate: 0,
};

const unwrapArray = res => {
  const inner = unwrap(res);
  return Array.isArray(inner) ? inner : [];
};

export const aMLiveStreamingStatsApi = createApi({
  reducerPath: 'aMLiveStreamingStatsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: [
    'Livestreaming Cards',
    'Livestreaming Monthly Trend',
    'Livestreaming Top Channels',
    'Livestreaming Top VOD',
    'Livestreaming Top Countries',
    'Livestreaming Top Domains',
    'Livestreaming Top ISPs',
    'Livestreaming M3U Files',
  ],
  endpoints: builder => ({
    getLivestreamingCards: builder.query({
      query: () => ({ url: '/analytics/livestreaming-cards/' }),
      transformResponse: res => ({ ...emptyCards, ...unwrap(res) }),
      providesTags: ['Livestreaming Cards'],
    }),
    getLivestreamingMonthlyTrend: builder.query({
      query: () => ({ url: '/analytics/livestreaming-monthly-trend/' }),
      transformResponse: unwrapArray,
      providesTags: ['Livestreaming Monthly Trend'],
    }),
    getLivestreamingTopChannels: builder.query({
      query: ({ period = 'year' } = {}) => ({
        url: '/analytics/livestreaming-top-channels/',
        params: { period },
      }),
      transformResponse: unwrapArray,
      providesTags: ['Livestreaming Top Channels'],
    }),
    getLivestreamingTopVod: builder.query({
      query: ({ period = 'year' } = {}) => ({
        url: '/analytics/livestreaming-top-vod/',
        params: { period },
      }),
      transformResponse: unwrapArray,
      providesTags: ['Livestreaming Top VOD'],
    }),
    getLivestreamingTopCountries: builder.query({
      query: ({ period = 'year' } = {}) => ({
        url: '/analytics/livestreaming-top-countries/',
        params: { period },
      }),
      transformResponse: unwrapArray,
      providesTags: ['Livestreaming Top Countries'],
    }),
    getLivestreamingTopDomains: builder.query({
      query: ({ period = 'year' } = {}) => ({
        url: '/analytics/livestreaming-top-domains/',
        params: { period },
      }),
      transformResponse: unwrapArray,
      providesTags: ['Livestreaming Top Domains'],
    }),
    getLivestreamingTopIsps: builder.query({
      query: ({ period = 'year' } = {}) => ({
        url: '/analytics/livestreaming-top-isps/',
        params: { period },
      }),
      transformResponse: unwrapArray,
      providesTags: ['Livestreaming Top ISPs'],
    }),
    getLivestreamingM3uFiles: builder.query({
      query: () => ({ url: '/analytics/livestreaming-m3u-files/' }),
      transformResponse: unwrapArray,
      providesTags: ['Livestreaming M3U Files'],
    }),
  }),
});

export const {
  useGetLivestreamingCardsQuery,
  useGetLivestreamingMonthlyTrendQuery,
  useGetLivestreamingTopChannelsQuery,
  useGetLivestreamingTopVodQuery,
  useGetLivestreamingTopCountriesQuery,
  useGetLivestreamingTopDomainsQuery,
  useGetLivestreamingTopIspsQuery,
  useGetLivestreamingM3uFilesQuery,
} = aMLiveStreamingStatsApi;
